module.exports = __webpack_public_path__ + "static/media/About-Page.1ef3939c.jpg";